import {defineMessages, FormattedMessage} from 'react-intl';
import {Link, Icon, view} from '@sail/ui';
import {chevronDown, chevronUp} from '@sail/icons/react/Icon';
import {CancelButton} from './CancelButton';
import {ScreenshareButton} from '../ScreenshareButton';
import {useEnabledScreenshareUi} from '../../../FeatureFlagsProvider';

const messages = defineMessages({
  title: {
    id: 'conversations_ui.widget.requestACallTopBar.title',
    description: 'Title of the request a call top bar',
    defaultMessage: 'Have us call you',
  },
  showDetails: {
    id: 'conversations_ui.widget.requestACallTopBar.showDetails',
    description: 'Toggle button to show more details about call state',
    defaultMessage: 'Show details',
  },
  hideDetails: {
    id: 'conversations_ui.widget.requestACallTopBar.hideDetails',
    description: 'Toggle button to hide details about call state',
    defaultMessage: 'Hide details',
  },
});

export const Title = ({
  showDetails,
  racStatus,
  isCancelLoading,
  onToggle,
  onCancel,
}: {
  showDetails: boolean;
  racStatus: 'pending' | 'cancelable' | 'calling';
  isCancelLoading: boolean;
  onToggle: () => void;
  onCancel: () => void;
}) => {
  const isScreenshareEnabled = useEnabledScreenshareUi();
  return isScreenshareEnabled ? (
    <view.div
      css={{
        font: 'label.medium.emphasized',
        stack: 'y',
        gap: 'small',
      }}
    >
      <view.div css={{stack: 'x', distribute: 'space-between'}}>
        <FormattedMessage {...messages.title} />
        <Link
          onPress={onToggle}
          css={{
            font: 'label.small.emphasized',
          }}
        >
          <FormattedMessage
            {...(showDetails ? messages.hideDetails : messages.showDetails)}
          />
          <Icon
            icon={showDetails ? chevronUp : chevronDown}
            size="xxsmall"
            css={{marginLeft: 'xsmall'}}
          />
        </Link>
      </view.div>
      <view.div css={{stack: 'x', gap: 'small'}}>
        <ScreenshareButton
          agentNames={racStatus === 'calling' ? ['Stripe Support'] : null}
          channel="rac"
        />
        <CancelButton
          screenshareRender
          isLoading={isCancelLoading}
          racStatus={racStatus}
          onCancel={onCancel}
        />
      </view.div>
    </view.div>
  ) : (
    <view.div
      css={{
        font: 'label.medium.emphasized',
        stack: 'x',
        distribute: 'space-between',
      }}
    >
      <FormattedMessage {...messages.title} />
      <view.div>
        <Link
          onPress={onToggle}
          css={{
            font: 'label.small.emphasized',
          }}
        >
          <FormattedMessage
            {...(showDetails ? messages.hideDetails : messages.showDetails)}
          />
          <Icon
            icon={showDetails ? chevronUp : chevronDown}
            size="xxsmall"
            css={{marginLeft: 'xsmall'}}
          />
        </Link>
        <CancelButton
          isLoading={isCancelLoading}
          racStatus={racStatus}
          onCancel={onCancel}
        />
      </view.div>
    </view.div>
  );
};
